// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1aypJ","select":"Header_select__1RUO5","clinic":"Header_clinic__V-U9s"};